export enum Age {
    '< 15 years' = '< 15 years',
    '15 - 25 years' = '15 - 25 years',
    '26 - 35 years' = '26 - 35 years',
    '35 - 45 years' = '35 - 45 years',
    '> 50 years' = '> 50 years',
}

export enum InvestmentExperience {
    '< 1 year' = '< 1 year',
    '2 - 5 years' = '2 - 5 years',
    '5 - 8 years' = '5 - 8 years',
    '9 - 10 years' = '9 - 10 years',
    '> 10 years' = '> 10 years',
}

export enum FinancialGoals {
    'Preserving Capital' = 'Preserving Capital',
    'Generating Income' = 'Generating Income',
    'Growing Capital' = 'Growing Capital',
    'Maximizing Tax efficiency' = 'Maximizing Tax efficiency',
}

export enum TimeHorizon {
    'Short Term' = 'Short Term',
    'Medium Term' = 'Medium Term',
    'Long Term' = 'Long Term',
}

export enum RiskTolerance {
    'Low' = 'Low',
    'Medium' = 'Medium',
    'High' = 'High',
}

export enum ReturnExpectations {
    'Conservative' = 'Conservative',
    'Moderate' = 'Moderate',
    'Aggressive' = 'Aggressive',
}

export enum ModelVersion {
    'ESG-Compliant' = 'ESG-Compliant',
    'Income-Focused' = 'Income-Focused',
    'Tax-Optimized' = 'Tax-Optimized',
}
